export default "__VITE_ASSET__Bn9bgU03__"